var exports = {
  "a": "Box__Ar9XKO",
};

module.exports = exports;
